// extracted by mini-css-extract-plugin
export var dropdownContainer = "_ok-0";
export var leftAlign = "_ok-4";
export var listItem = "_ok-2";
export var listItemWrapper = "_ok-1";
export var operationText = "_ok-3";